import React from 'react'
import Header from '../../../home/Header'
import Footer from '../../Footer'
import TermsOfUse from './TermsOfUse'

export default function index() {
  return (
    <div>
        <Header/>
        <TermsOfUse/>
        <Footer/>
    </div>
  )
}
